export const extendedKeyLabelMap: Record<string, string> = {
  // Main fields
  _id: "ID",
  article_url: "Article URL",
  child_authors: "Child Authors",
  content: "Content",
  country: "Country",
  created_by_id: "Created By ID",
  updated_by_id: "Updated By ID",
  date_created: "Date Created",
  date_updated: "Date Updated",
  date_publish: "Date Published",
  entities_id: "Entities",
  influencer_id: "Influencer",
  media_source: "Media Source",
  section: "Section",
  tiktok_ids: "TikTok IDs",
  tiktok_urls: "TikTok URLs",
  bm_img_vid_urls: "BM Image/Video URLs",
  parent_authors: "Parent Authors",
  language: "Language",
  article_clean_url: "Post URL",
  child_count: "Child Count",
  publisher: "Publisher",
  media_value: "Media Value",
  audio_video_program: "Audio/Video Program",
  audio_video_id: "Audio/Video ID",
  audio_video_multipliers: "Audio/Video Multipliers",
  nav_segment_length: "Nav Segment Length",
  nav_segment_type: "Nav Segment Type",
  tld_io_video_source: "TLD IO Video Source",
  article_img: "Article Image",
  article_color: "Article Color",
  article_number_of_pages: "Article Number of Pages",
  article_page_dimension: "Article Page Dimension",
  article_is_art_white_page: "Article Is Art White Page",
  articles_app_forum: "Articles App Forum",
  city: "City",
  place_source: "Place Source",
  soc_content_type: "Content Type",
  soc_post_id: "Post ID",
  soc_source: "Platform",
  soc_type: "Type",

  // Engagement fields
  soc_mm_score: "MM Score",
  soc_view_count: "Views",
  soc_share_count: "Shares",
  soc_er_score: "ER Score",
  soc_wow_count: "Wow Count",
  soc_eng_score: "Engagement Score",
  soc_comment_count: "Comments",
  soc_love_count: "Love Count",
  soc_angry_count: "Angry Count",
  soc_save_count: "Save Count",
  soc_like_count: "Likes",
  soc_sad_count: "Sad Count",
  soc_haha_count: "Haha Count",
  soc_te_score: "TE Score",
  soc_dislike_count: "Dislike Count",
  soc_kf_score: "KF Score",
};
